import React from "react";
import {
  Section,
  HeaderSection,
  Title,
  UploadList,
} from "../primitives";
import FileDownloadRow from "../FileDownloadRow";

const DownloadSection = ({ downloadFiles }) => {
  if (!downloadFiles || downloadFiles.length === 0) {
    return null;
  }

  return (
    <Section>
      <HeaderSection>
        <Title>Downloads</Title>
      </HeaderSection>

      <UploadList>
        {downloadFiles.map((downloadConfig, index) => (
          <FileDownloadRow
            key={downloadConfig.value || index}
            downloadConfig={downloadConfig}
          />
        ))}
      </UploadList>
    </Section>
  );
};

export default DownloadSection;

